module.exports = __webpack_public_path__ + "img/ic_doc.2f0dfa70.svg";